import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, TransitionGroup as _TransitionGroup, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["href", "title"]
const _hoisted_2 = ["src", "alt"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_carousel_navigation = _resolveComponent("base-carousel-navigation")
  const _component_base_carousel = _resolveComponent("base-carousel")

  return ($props.partners.length > 0)
    ? (_openBlock(), _createBlock(_component_base_carousel, {
        key: 0,
        autoplay: true,
        items: $props.partners,
        class: "gfu-base-carousel",
        onChange: $options.onChange
      }, {
        view: _withCtx(() => [
          _createVNode(_TransitionGroup, {
            name: $options.transitionName,
            tag: "div",
            class: "_flex _ov-h gfu-base-carousel-wrapper"
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.slides, (slide) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: slide.name,
                  class: _normalizeClass(['gfu-1of2 gfu-1of4--m _px-6'])
                }, [
                  _createElementVNode("a", {
                    href: slide.creatorUrl,
                    class: "gfu-embed gfu-embed--1x1",
                    title: slide.name
                  }, [
                    _createElementVNode("img", {
                      class: "gfu-embed__item _pa-1",
                      src: `${slide.imageUrl}?v=2`,
                      alt: slide.name,
                      loading: "lazy"
                    }, null, 8 /* PROPS */, _hoisted_2)
                  ], 8 /* PROPS */, _hoisted_1)
                ]))
              }), 128 /* KEYED_FRAGMENT */))
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["name"])
        ]),
        nav: _withCtx(({ onNext, onPrev }) => [
          _createVNode(_component_base_carousel_navigation, {
            type: "prev",
            icon: "angle-left",
            class: "gfu-partners-slider-nav--prev",
            onClick: onPrev
          }, null, 8 /* PROPS */, ["onClick"]),
          _createVNode(_component_base_carousel_navigation, {
            type: "next",
            icon: "angle-right",
            class: "gfu-partners-slider-nav--next",
            onClick: onNext
          }, null, 8 /* PROPS */, ["onClick"])
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["items", "onChange"]))
    : _createCommentVNode("v-if", true)
}